"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherRef = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var TeacherRef = function TeacherRef() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M19.64,15.13c-2.85,0.25-5.85,1.29-8.29,3.87c-5.58,5.9-7.68,19.56,2.34,34.92c0,0,5.82,8.81,12.61,8.41\r c6.79-0.4,3.88-0.89,7.76-0.81c3.88,0.08,5.17,1.46,8.81,0.81s15.6-11.96,15.44-28.45S48.94,15.52,47.73,15.2\r c-1.21-0.32-6.87-1.05-10.59,1.13c-1.52,0.89-2.78,1.26-3.95,1.3"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M32.7,17.06c0,0-0.17-10.33,7.79-14.56"
      })]
    })
  });
};
exports.TeacherRef = TeacherRef;